import type { ReactNode } from 'react';
import { Icon } from './Icon';

interface HeroProps {
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  /** Breadcrumb content rendered in place of the title block when provided. */
  crumb?: ReactNode;
}

/** Blue gradient hero header shared by the dashboard and editor (US4). */
export function Hero({ eyebrow, title, subtitle, crumb }: HeroProps) {
  return (
    <div className="relative overflow-hidden bg-hero-gradient text-white">
      <div className="flex items-center justify-between px-10 py-4">
        <div className="flex items-center gap-2.5 text-[0.95rem] font-extrabold">
          <span className="flex h-[30px] w-[30px] items-center justify-center rounded-lg bg-white/20">
            <Icon name="logoWhite" size={14} />
          </span>
          Vane Loop
        </div>
      </div>
      {crumb ? (
        <div className="px-10 pb-4 text-sm opacity-80">{crumb}</div>
      ) : (
        <div className="px-10 pb-7 pt-2">
          {eyebrow && (
            <div className="mb-1.5 text-xs font-bold uppercase tracking-widest opacity-65">
              {eyebrow}
            </div>
          )}
          {title && (
            <div className="mb-1 text-3xl font-extrabold leading-tight tracking-tight">
              {title}
            </div>
          )}
          {subtitle && <div className="text-sm opacity-75">{subtitle}</div>}
        </div>
      )}
    </div>
  );
}
